export const colors =[
    "#2A3D5C", // Deep slate blue
    "#2E4053", // Charcoal blue
    "#3C6E71", // Deep teal green
    "#3A4C5C", // Dark blue-grey
    "#355C7D", // Cool steel blue
    "#4F6272", // Muted slate grey
    "#5C6D7C", // Soft navy
    "#4A6572", // Dusty blue
    "#3E5C6A", // Steel teal
    "#2F4F4F",  // Dark sea green
    "#1E1E1E", // Almost black
    "#2C3E50", // Dark blue-gray
    "#34495E", // Muted navy
    "#8E44AD", // Rich purple
    "#C0392B", // Strong red
    "#D35400", // Deep orange
    "#16A085", // Dark teal
    "#27AE60", // Deep green
    "#2980B9", // Strong blue
    "#F39C12", // Bold yellow-orange
    "#E67E22", // Burnt orange
    "#8B0000", // Dark red
    "#004953", // Deep cyan
    "#3D3B8E", // Strong indigo
    "#5D4157", // Deep mauve
  ];